// src/services/rpc-server-events.ts
var RPCServerEventsExplicitSubscribe = /* @__PURE__ */ new Set([
	"OpsActivityFeedUpdated",
	"ServicePeriodInstanceChanged",
	"UserGeoLocationChanged",
	"UserConnectedStateChanged",
	"UserPhysicalActivityChanged"
]);
export { RPCServerEventsExplicitSubscribe };

//# sourceMappingURL=rpc-server-events.js.map